import { render } from "./ProfileAvatar.vue?vue&type=template&id=3b20e47c&scoped=true&ts=true"
import script from "./ProfileAvatar.vue?vue&type=script&lang=ts"
export * from "./ProfileAvatar.vue?vue&type=script&lang=ts"

import "./ProfileAvatar.vue?vue&type=style&index=0&id=3b20e47c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b20e47c"],['__file',"src/components/profile/ProfileAvatar.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3b20e47c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3b20e47c', __exports__)) {
    api.reload('3b20e47c', __exports__)
  }
  
  module.hot.accept("./ProfileAvatar.vue?vue&type=template&id=3b20e47c&scoped=true&ts=true", () => {
    api.rerender('3b20e47c', render)
  })

}


export default __exports__